export default {"src":"/_next/static/image/public/images/flags/flag_254.a6881ce841484b1dad6c5847c8ffc704.svg","height":16,"width":24};